import {Component, OnInit, Optional} from '@angular/core';
import { Router } from '@angular/router';
import {ClientITProfile, Project, User} from '../../_models';
import {
  AlertService,
  AuthenticationService, ClientProfileService,
  ProjectService,
} from '../../_services';
import { LoginHelper, Recurring, StringsHelper } from '../../helpers';
import {DynamicDialogRef} from "primeng/dynamicdialog";

@Component({
    standalone: false,
  selector: 'select-project-control-item',
  templateUrl: 'select-device.component.html',
  styleUrls: ['./select-device.component.scss'],
})
export class SelectDeviceComponent implements OnInit {
  itProfiles: ClientITProfile[] = [];
  currentUser: User;
  recurringList: any;
  rowGroupMetadata: any = {};

  cols: any[] = [
    { 'field': 'controlItem.complianceAreaControlId', 'header': 'Control ID' },
    { 'field': 'controlItem.category', 'header': 'Category' },
    { 'field': 'controlItem.description', 'header': 'Description' },
  ];

  constructor(
    public clientProfileService: ClientProfileService,
    public router: Router,
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    public dialogRef: DynamicDialogRef,
  ) {}

  ngOnInit() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }
    this.recurringList = [];
    for (let i = 0; i <= Recurring.Yearly; i++) {
      this.recurringList[i] = Recurring[i].toString();
    }

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    this.clientProfileService.getClientProfiles(LoginHelper.getTenantName()).subscribe(
      (itProfiles) => {
        this.itProfiles = itProfiles;
      },

      (error) => {
        const errorMessage = 'An error occurred while loading profiles.';
        this.alertService.error(errorMessage);
      }
    );
  }

  getDevices(event) {
    if (
      event.data.devices &&
      event.data.devices.length
    ) {
      return event.data.devices;
    }
    event.data.loading = true;
    this.clientProfileService.getClientProfile(event.data.clientITProfileId, LoginHelper.getTenantName()).subscribe((p) => {
      event.data.loading = false;
      event.data.devices = p.devices;
    });
  }
  getFullName(user: User) {
    return StringsHelper.getFullName(user);
  }

  selectDevice(data) {
    data.clientITProfileName = this.itProfiles.find(
      (p) => p.clientITProfileId == data.clientITProfileId
    ).name;
    this.dialogRef.close(data);
  }
}
